import {
    Route,
    Routes
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from "./pages/EditPage.tsx";

export const UserProfileAttributesLayout = () => (
    <Routes>
        <Route
            path="/"
            element={<IndexPage/>}
        />
        <Route
            path="/update"
            element={<EditPage/>}
        />

    </Routes>
);
